<template>
    <div>
        <v-snackbar
                v-model="model"
                :color="alertType"
                :multi-line="mode === 'multi-line'"
                :timeout="timeout"
                top="top"
        >
            {{message}}
        </v-snackbar>

    </div>
</template>

<script>

export default {
    data: () => ({
        timeout: 3000,
        mode:''
    }),

    computed:{
        model () {
            return this.show?this.show:false;
        }
    },
    props:["show", "message", "alertType"]
}
</script>
